import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import history from 'app/routes/history';

import { Badge } from 'reactstrap';
import Checkbox from 'app/components/general/Checkbox';

import Table from 'app/components/general/Table';
import Button from 'app/components/general/Button';

import * as teamsSelectors from 'app/ducks/teams/selectors';

interface ITeamsTableSelectableProps {
  teamsById: any;
  teamIds: any;
  headerTitle: string;
  initialFilterConfig: any;
  persistentFilterConfig: any;
  isLoading: boolean;
  pagination: any;
  manual: boolean;
  selectTeam: any;
  handleCreate: any;
  updateSelectedRows: any;
}

interface ITeamsTableSelectableState {
  selectedRows: any;
  selectedAllRows: boolean;
}
export default class TeamsTableSelectable extends React.Component<
  ITeamsTableSelectableProps,
  ITeamsTableSelectableState
> {
  static defaultProps: ITeamsTableSelectableProps = {
    teamsById: undefined,
    teamIds: undefined,
    headerTitle: undefined,
    initialFilterConfig: undefined,
    persistentFilterConfig: undefined,
    isLoading: false,
    manual: true,
    pagination: undefined,
    selectTeam: undefined,
    handleCreate: undefined,
    updateSelectedRows: undefined,
  };

  state = {
    selectedRows: {},
    selectedAllRows: false,
  };

  constructTeamsData = (teamsById, teamIds) => {
    if (
      teamsById !== undefined
      && !_.isEmpty(teamsById)
      && teamIds !== undefined
    ) {
      const teamRows = _.reduce(
        teamIds,
        (acc, id) => {
          if (!_.isEmpty(teamsById[id])) {
            acc.push(teamsSelectors.getTeamSummary(teamsById[id]));
          }
          return acc;
        },
        [],
      );

      return teamRows;
    }
    return [];
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (!_.isEqual(prevState.selectedRows, this.state.selectedRows)) {
      const parsedSelectedRows = _.pickBy(this.state.selectedRows, (o) => o);
      this.props.updateSelectedRows(_.keys(parsedSelectedRows));
    }
  };

  onFetchData = (props, state, instance) => {
    const { pageSize } = state;
    const pageNumber = state.page;
    const sort = instance.state.sorted;
    const filter = state.filtered;
    // console.log(this.props, filter);

    if (
      props.appReady
      && !props.isLoading
      && (pageNumber !== props.pagination.page.number
        || (!_.isEmpty(sort) && sort !== props.pagination.sort)
        || filter !== props.pagination.filter)
    ) {
      props.actions.getAllTeams({
        page: {
          size: pageSize,
          number: pageNumber,
        },
        sort,
        filter,
      });
    }
  };

  selectRow = (id) => {
    this.setState((previousState) => ({
      selectedRows: {
        ...previousState.selectedRows,
        [id]: !previousState.selectedRows[id],
      },
    }));
  };

  selectAllRows = (rows) => {
    const selectedRows = {};
    const selectionValue = !this.state.selectedAllRows;

    _.map(rows, (row) => {
      selectedRows[row.id] = selectionValue;
    });

    this.setState((previousState) => ({
      selectedAllRows: !previousState.selectedAllRows,
      selectedRows,
    }));
  };

  render(): React.ReactNode {
    const data = this.constructTeamsData(
      this.props.teamsById,
      this.props.teamIds,
    );

    const columns = [
      {
        Header: (props) => (
          <Checkbox
            onClick={() => this.selectAllRows(props.data)}
            checked={this.state.selectedAllRows}
          />
        ),
        accessor: 'id',
        className: 'col col-1',
        headerClassName: 'col col-1 ',
        sortable: false,
        Cell: (props) => (
          <Checkbox
            onClick={() => this.selectRow(props.value)}
            checked={this.state.selectedRows[props.value]}
          />
        ),
      },
      {
        Header: 'Name',
        accessor: 'name',
        className: 'col',
        headerClassName: 'col',
      },
      {
        Header: 'Status',
        className: 'col',
        headerClassName: 'col',
        accessor: 'status',
        Cell: (cellProps) => (
          <span
            className={classnames(
              {
                'color-green': cellProps.value.includes('Up to Date'),
              },
              {
                'color-grey': cellProps.value.includes('Owing'),
              },
              {
                'color-red': cellProps.value.includes('Overdue'),
              },
            )}
          >
            {cellProps.value}
          </span>
        ),
      },
    ];

    const filterOptions = [
      {
        label: 'Name',
        accessor: 'name',
        type: 'text',
      },
      {
        label: 'Status',
        accessor: 'status',
        type: 'select',
        options: [
          { id: 'owing', name: 'Owing' },
          { id: 'overdue', name: 'Overdue' },
          { id: 'none', name: 'Up to Date' },
        ],
      },
    ];

    return (
      <Table
        cardClassName="border-card"
        headerTitle={this.props.headerTitle}
        objectTitle="teams"
        filterTitle="Teams Data"
        isLoading={this.props.isLoading}
        data={data}
        columns={columns}
        manual={this.props.manual}
        showPagination={false}
        onFetchData={(state, instance) => this.onFetchData(this.props, state, instance)}
        filterOptions={filterOptions}
        filterConfig={this.props.initialFilterConfig}
        persistentFilterConfig={this.props.persistentFilterConfig}
        pagination={this.props.pagination}
      />
    );
  }
}
